import httpClient from './httpClient';

// Legacy ephemeral report (kept for compatibility)
const getReport = async (startDate, endDate, filters = {}, page = 1, pageSize = 100) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
    page,
    page_size: pageSize,
  };

  if (filters.client_id) params.client_id = filters.client_id;
  if (filters.supplier_id) params.supplier_id = filters.supplier_id;
  if (filters.product_id) params.product_id = filters.product_id;
  if (filters.include_non_purchase_sources) {
    params.include_non_purchase_sources = filters.include_non_purchase_sources;
  }

  const response = await httpClient.get('/api/reports/bar-stock-consumption', { params });
  return response.data;
};

// Legacy direct export (kept for compatibility)
const exportReport = async (startDate, endDate, filters = {}) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  };

  if (filters.client_id) params.client_id = filters.client_id;
  if (filters.supplier_id) params.supplier_id = filters.supplier_id;
  if (filters.product_id) params.product_id = filters.product_id;
  if (filters.include_non_purchase_sources) {
    params.include_non_purchase_sources = filters.include_non_purchase_sources;
  }

  const response = await httpClient.get('/api/reports/bar-stock-consumption/export', {
    params,
    responseType: 'blob',
  });

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let fileName = `棒料采购消耗报表_${startDate}_${endDate}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

// Report runs (preferred Web UI flow)
const createRun = async (startDate, endDate, filters = {}) => {
  const payload = {
    start_date: startDate,
    end_date: endDate,
    include_non_purchase_sources: Boolean(filters.include_non_purchase_sources),
  };

  if (filters.client_id) payload.client_id = filters.client_id;
  if (filters.supplier_id) payload.supplier_id = filters.supplier_id;
  if (filters.product_id) payload.product_id = filters.product_id;

  const response = await httpClient.post('/api/reports/bar-stock-consumption/runs', payload);
  return response.data;
};

const getRuns = async (page = 1, pageSize = 20) => {
  const response = await httpClient.get('/api/reports/bar-stock-consumption/runs', {
    params: { page, page_size: pageSize },
  });
  return response.data;
};

const getRun = async (runId) => {
  const response = await httpClient.get(`/api/reports/bar-stock-consumption/runs/${runId}`);
  return response.data;
};

const exportRun = async (runId) => {
  const response = await httpClient.get(
    `/api/reports/bar-stock-consumption/runs/${runId}/export`,
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  const contentDisposition = response.headers['content-disposition'];
  let fileName = `棒料采购消耗报表_${runId}.xlsx`;
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match) {
      fileName = decodeURIComponent(match[1]);
    }
  }

  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const barStockConsumptionReportService = {
  getReport,
  exportReport,
  createRun,
  getRuns,
  getRun,
  exportRun,
};

export default barStockConsumptionReportService;
